export const URI = 'https://insights-258706.appspot.com/';
